import React from 'react';
import useData from '@/hooks/useData';
import LoadingScreen from '@/components/LoadingScreen';
import useViewportHeight from './hooks/useViewportHeight';

const CaptchaPage = React.lazy(() => import('@/pages/captcha-page/CaptchaPage'));
const LandingPage = React.lazy(() => import('@/pages/landing-page/LandingPage'));

const App = () => {
	const data = useData();
	useViewportHeight();

	let component = null;
	switch (data.page_type as string) {
		case 'landingPage':
		case 'landing-page':
		case 'landing_page':
			component = <LandingPage />;
			break;
		case 'captchaPage':
		case 'captcha-page':
		case 'captcha_page':
			component = <CaptchaPage />;
			break;
		default:
			component = <LoadingScreen />;
			break;
	}

	return (
		<>
			<React.Suspense fallback={<LoadingScreen fullPage={true} />}>{component}</React.Suspense>
		</>
	);
};

export default App;
